import PropTypes from "prop-types";

import ELAQuizStandardsDropdown from "../QuizElaStandardsDropdown";
import {
  standardsContentCss,
  standardsElementContentCss,
  standardsTitleCss,
} from "./QuizElaStandardsSection.style";

const propTypes = {
  standards: PropTypes.shape({
    id: PropTypes.string,
    data: PropTypes.object,
  }),
};

const QuizElaStandardsSection = ({ standards }) => {
  if (!standards) return null;

  return (
    <div css={standardsContentCss}>
      <div>
        <h3 css={standardsTitleCss}>Standards</h3>
      </div>
      <div css={standardsElementContentCss}>
        <ELAQuizStandardsDropdown id={standards.id} standard={standards.data} />
      </div>
    </div>
  );
};

QuizElaStandardsSection.propTypes = propTypes;

export default QuizElaStandardsSection;
